import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'

@Component({
   selector: 'app-confirm-dialog',
   imports: [MatDialogModule, MatButtonModule],
   template: `
      <h2 mat-dialog-title>{{ data.title }}</h2>
      <mat-dialog-content class="mat-typography">
         <p>{{ data.message }}</p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
         <button
            class="v-button v-button-lg v-white mr-3 mb-3"
            (click)="close(false)">
            Cancel
         </button>
         <button
            class="v-button v-button-lg v-darkgreen mb-3"
            (click)="close(true)">
            Finalize
         </button>
      </mat-dialog-actions>
   `,
})
export class ConfirmDialogComponent {
   constructor(
      private ref: MatDialogRef<ConfirmDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
   ) {}

   close(result: boolean) {
      this.ref.close(result)
   }
}
